<button
  [title]="columnsSettingsTitle"
  class="btn btn-icon btn-secondary"
  (click)="openColumnChooser()"
  [disabled]="disabled"
>
  <i class="f-i f-i-settings"></i>
</button>
